<template>
  <section class="store section">
    <div class="gears-parent">
      <Gear/>
    </div>
    <img class="torihiki-img vertical-move" src="../../assets/Sections/torihiki.png"/>

    <div class="store-text">
      <table>
        <tr>
          <td class="left">
            Title
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            La Kasketia
          </td>
        </tr>

        <tr>
          <td class="left">
            Circle
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            toyKasket
          </td>
        </tr>

        <tr>
          <td class="left">
            Release Date
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            2018.08.10
          </td>
        </tr>

        <tr>
          <td class="left">
            Place
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            コミックマーケット94 1日目(金) 西ほ-20b
          </td>
        </tr>

        <tr>
          <td class="left">
            Event Price
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            1000yen
          </td>
        </tr>

        <tr>
          <td class="left">
            Shop Price
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            1300yen
          </td>
        </tr>

        <tr>
          <td class="left">
            Specification
          </td>
          <td class="center">
            :
          </td>
          <td class="right">
            CD-R(ジュエルケース)
          </td>
        </tr>
      </table>
    </div>

    <div class="columns">
      <div class="column is-offset-5">
        <a href="static/lakasketia-jacket.png" target="_blank">
          <div class="card jacket">
            <div class="card-image">
              <figure class="image">
                <img src="static/jacket-mini.jpg" alt="Placeholder image">
              </figure>
            </div>
          </div>
        </a>
      </div>
      <div class="column is-5"></div>
    </div>

    <div class="columns">
      <div class="column is-offset-2">
        <Button text="Diverse Direct" link="https://diverse.direct/toykasket/tkcd-0004/" :uc="false"/>
      </div>
      <div class="column">
        <Button text="メロンブックス" link="https://www.melonbooks.co.jp/detail/detail.php?product_id=389653" :uc="false"/>
      </div>
      <div class="column">
        <Button text="TANO*C STORE" link="http://www.tanocstore.net/shopdetail/000000001681/toyKasket/page1/recommend/" :uc="false"/>
      </div>
      <div class="column is-2"></div>
    </div>

    <div class="rights">
      - toyKasket 2018. All Rights Reserved. -
    </div>
  </section>
</template>

<script>
  import Button from '../Controlls/Button';
  import Gear from '../Parts/Gear';

  export default {
    name: "Store",
    components: {
      Button, Gear
    },
  }
</script>

<style scoped lang="scss">
  .store {
    position: relative;
    background: url("../../assets/Loading/bg-loading.png") repeat;
    min-height: 100vh;
    animation: move-bg 10s infinite linear;
    &:before {
      content: '';
      position: absolute;
      height: 100%;
      width: 10vw;
      top: 0;
      left: 0;
      background: #2c3e50;
      overflow: hidden;
      opacity: 0.5;
    }

    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 10vw;
      top: 0;
      right: 0;
      background: #2c3e50;
      overflow: hidden;
      opacity: 0.5;
    }
  }

  @keyframes move-bg {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: 375px 302px;
    }
  }

  .torihiki-img {
    display: flex;
    margin: auto;
  }

  .vertical-move {
    animation: vertical 2s ease-in-out infinite alternate;
  }

  @keyframes vertical {
    0% {
      transform: translateY(-2px);
    }
    100% {
      transform: translateY(2px);
    }
  }

  .store-text {
    position: relative;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #f8f3d9;
    font-weight: bold;
    font-style: italic;
    font-size: x-large;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    @media screen and (max-width: 768px) {
      font-size: medium;
    }
    table {
      width: 100%;
    }
    .left {
      width: 45%;
      text-align: right;
      font-size: small;
      bottom: 0;
      @media screen and (max-width: 768px) {
        width: 20%;
      }
    }
    .right {
      width: 45%;
      text-align: left;
      @media screen and (max-width: 768px) {
        width: 70%;
      }
    }
    .center {
      width: 10%;
      text-align: center;
    }
  }

  .gears-parent {
    position: absolute;
    left: 47%;
    margin-top: 140px;
    width: 250px;
    z-index: 0;
    @media screen and (max-width: 768px) {
      width: 40%;
      left: 38%;
    }
  }

  .rights {
    text-align: center;
    font-style: italic;
    font-weight: bold;
    color: #f8f3d9;
  }

  .jacket {
    border: solid 10px #f8f3d9;
    &:hover {
      cursor: pointer;
      left: 5px;
      bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Sections/Store.vue